// The exported code uses Tailwind CSS. Install Tailwind CSS in your dev environment to ensure all styles work.
import React, { useState, useEffect } from "react";
import Header from "../../component/_elements/Header.tsx";
import { data, Link, useNavigate, useOutletContext } from "react-router-dom";
import {
  EleveType,
  OutletContextType,
  ParentType,
  requestType,
  schooYearType,
} from "../../types/GlobalType.ts";
import { ANNEE_SCOLAIRE } from "../../App.constants.js";
import { Skeleton } from "@mui/material";
import { catchErrorApiCall } from "../../_services/apiUtils.js";
import { API_CONFIG } from "../../apiCaller/configuration.Caller.js";
import { accountService } from "../../_services/accountServices.js";
import toast from "react-hot-toast";
import { API_PARENT } from "../../apiCaller/perent.Callerl.js";
import { API_ELEVE } from "../../apiCaller/eleve.Caller.js";
import moment from "moment";
import { API_CLASSE } from "../../apiCaller/classe.Caller.js";
import { useQuery } from "@tanstack/react-query";
import {
  studentControler,
  StudentType,
} from "../../_api/controllers/student.controller.ts";
import { parentController } from "../../_api/controllers/parent.controller.ts";
import {
  classeController,
  motifPaiementController,
  promotionController,
  schoolYearController,
} from "../../_api/controllers/scolarite.controller.ts";
import { capitalizeFirstLetter } from "../../_services/utils.jsx";
import { studentAttendanceController } from "../../_api/controllers/attendance.controller.ts";
import { paymentController } from "../../_api/controllers/payment.controller.ts";
import { personalController } from "../../_api/controllers/personal.controller.ts";
const Student: React.FC = () => {
  const { isDarkMode, setIsDarkMode } = useOutletContext<OutletContextType>();
  const [currentYear, setCurrentYear] = useState("2025 - 2026");
  const [isYearDropdownOpen, setIsYearDropdownOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedClass, setSelectedClass] = useState("Toutes les classes");
  const [selectedStatus, setSelectedStatus] = useState<any>("Tous les statuts");
  const [isClassDropdownOpen, setIsClassDropdownOpen] = useState(false);
  const [isStatusDropdownOpen, setIsStatusDropdownOpen] = useState(false);
  const [viewMode, setViewMode] = useState("liste");
  const [showAddModal, setShowAddModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [isExportDropdownOpen, setIsExportDropdownOpen] = useState(false);
  const studentsPerPage = 100;

  const handleNavigateToStudentDetails = (student: any) => {
    console.log(student);
    navigate(`/eleves/${student.id}`, {
      state: student, // 👈 pass data here
    });
  };

  // ---------------------------------------------------------------------
  // -------------VARAIBLES & FUNCTIONS FOR PREVIOUS VERSION--------------
  // ---------------------------------------------------------------------
  const [dataEleve, setDataEleve] = useState<EleveType[]>([]);
  // const [dataClasses, setDataClasses] = useState<ClasseType[]>([]);

  const [singleDataEleve, setsingleDataEleve] = useState<EleveType>();

  const [dataSY, setDataSY] = useState<schooYearType[]>([]);
  const [openSingle, setOpenSingle] = useState<Boolean>(false);
  const [dataParent, setDataParent] = useState<ParentType[]>([]);
  const [reloadStateTwo, setreloadStateTwo] = useState(0);

  const [selectedAnneeValue, setselectedAnneeValue] = useState<string>(
    ANNEE_SCOLAIRE[ANNEE_SCOLAIRE.length - 1]
  );
  const [searchValue, setSearchValue] = useState<string>("");

  const navigate = useNavigate();

  const [state, setState] = React.useState<requestType>({
    isLoading: false,
    errorMessage: false,
    successMessage: false,
  });
  const [stateEleve, setStateEleve] = React.useState<requestType>({
    isLoading: false,
    errorMessage: false,
    successMessage: false,
  });
  const [stateParent, setStateParent] = React.useState<requestType>({
    isLoading: false,
    errorMessage: false,
    successMessage: false,
  });

  const { data: eleveData } = useQuery({
    queryKey: ["students"],
    queryFn: studentControler.getAll,
  });

  //sclarité request
  const { data: parentsData } = useQuery({
    queryKey: ["parents"],
    queryFn: parentController.getAll,
  });

  //fetch promotion
  const { data: promotionsData } = useQuery({
    queryKey: ["promotions"],
    queryFn: promotionController.getAll,
  });

  //fetch classe
  const { data: dataClasseObj } = useQuery({
    queryKey: ["classes"],
    queryFn: classeController.getAll,
  });

  //fetch anne scolaire
  const { data: schoolYear } = useQuery({
    queryKey: ["schoolYears"],
    queryFn: schoolYearController.getAll,
  });

  // fetch Active schoolYear
  const { data: activeSchoolYear } = useQuery({
    queryKey: ["ActiveSchoolYear"],
    queryFn: schoolYearController.getActive,
  });

  // fetch personals
  useQuery({
    queryKey: ["personals"],
    queryFn: personalController.getAll,
  });

  // fetch motif Paiement
  const { data: motifPaiementData } = useQuery({
    queryKey: ["motifPaiement"],
    queryFn: motifPaiementController.getAll,
  });

  //fetch attendance of the current month
  const date = moment().format("YYYY-MM-DD");
  useQuery({
    queryKey: ["studentAttendance"],
    queryFn: () => studentAttendanceController.getAllByMonth(date),
  });

  //fetch paiement of current student of cactive school year
  useQuery({
    queryKey: ["payments"],
    queryFn: paymentController.getAll,
  });

  const dataClasses = dataClasseObj?.data ? dataClasseObj.data : [];
  const dataParentArr = parentsData?.data ? parentsData.data : [];
  const dataPromotionArr = promotionsData?.data ? promotionsData.data : [];

  const toggleDarkMode = () => {
    setIsDarkMode(!isDarkMode);
  };
  const toggleYearDropdown = () => {
    setIsYearDropdownOpen(!isYearDropdownOpen);
  };
  const toggleClassDropdown = () => {
    setIsClassDropdownOpen(!isClassDropdownOpen);
    if (isClassDropdownOpen) setIsStatusDropdownOpen(false);
  };
  const toggleStatusDropdown = () => {
    setIsStatusDropdownOpen(!isStatusDropdownOpen);
    if (isStatusDropdownOpen) setIsClassDropdownOpen(false);
  };

  const toggleExportDropdown = () => {
    setIsExportDropdownOpen(!isExportDropdownOpen);
  };

  const exportData = (format: string) => {
    // Convert filtered payments to Excel format
    const data = currentStudents.map((student) => ({
      Noms: ` ${student.nom} ${student.postnom} ${capitalizeFirstLetter(
        student.prenom
      )}`,
      Classe: student.classeDesignation,
      Genre: student.sexe === "M" ? "M" : "F",
      Naisssance: student.date_naissance,
      Contact: student.telephone,

      // Méthode: payment.methode,
    }));
    // Create Excel-like content
    const headers = Object.keys(data[0]);
    const excelContent = [
      headers.join("\t"),
      ...data.map((row: any) =>
        headers.map((header) => row[header]).join("\t")
      ),
    ].join("\n");
    // Create and trigger download
    const blob = new Blob([excelContent], {
      type: "text/tab-separated-values;charset=utf-8;",
    });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `paiements_${new Date().toISOString().split("T")[0]}.xls`;
    link.click();
    // Show success notification
    const notification = document.createElement("div");
    notification.className = `fixed bottom-4 right-4 px-6 py-3 rounded-lg text-white ${
      isDarkMode ? "bg-green-600" : "bg-green-500"
    } shadow-lg transition-opacity duration-500`;
    notification.innerHTML =
      '<i class="fas fa-check-circle mr-2"></i>Export Excel réussi';
    document.body.appendChild(notification);
    setTimeout(() => {
      notification.style.opacity = "0";
      setTimeout(() => notification.remove(), 500);
    }, 3000);
    setIsExportDropdownOpen(false);
  };
  // Données des élèves
  const parentDataArr = eleveData?.data ? eleveData.data : [];

  //Create explicite dataArray for students
  let updatedStudents: StudentType[] = parentDataArr.map((student) => {
    let parentData: any,
      promotionData: any,
      classeDesignation: any,
      classeId: any;

    for (const parent of dataParentArr) {
      if (parent.parent_id === student.parent_id) {
        parentData = parent;
      }
    }
    for (const promotion of dataPromotionArr) {
      if (
        promotion.annee_scolaire_id === schoolYear?.data[0].id &&
        promotion.eleve_id === student.eleve_id
      ) {
        promotionData = promotion;
        //it is possible to get all promotion of the current student here by handling the condition above
      }
    }
    for (const classe of dataClasses) {
      if (promotionData?.classe_id === classe.id) {
        classeDesignation = classe.designation;
        classeId = classe.id;
      }
    }

    return {
      ...student,
      parentData: parentData,
      promotionData: promotionData,
      classeDesignation: classeDesignation,
      classeId: classeId,
    };
  });

  const students = [...updatedStudents];

  // Filtrer les élèves selon la recherche et les filtres
  const filteredStudents = students.filter((student: any) => {
    const matchesSearch =
      student?.nom.toLowerCase().includes(searchQuery.toLowerCase()) ||
      student.prenom?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      student.postnom?.toLowerCase().includes(searchQuery.toLowerCase());

    const matchesClass =
      selectedClass === "Toutes les classes" ||
      student.classeDesignation?.toLowerCase() === selectedClass.toLowerCase();

    const matchesStatus =
      selectedStatus === "Tous les statuts" || student.status == selectedStatus;
    return matchesSearch && matchesClass && matchesStatus;
  });
  const indexOfLastStudent = currentPage * studentsPerPage;
  const indexOfFirstStudent = indexOfLastStudent - studentsPerPage;
  const currentStudents = filteredStudents.slice(
    indexOfFirstStudent,
    indexOfLastStudent
  );
  const totalPages = Math.ceil(filteredStudents.length / studentsPerPage);
  const handlePageChange = (pageNumber: number) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  //Handle mouse click outside for dropdowns
  const ExportDropdownRef = React.useRef<HTMLDivElement>(null);
  const ClassDropdownRef = React.useRef<HTMLDivElement>(null);
  const StatusDropdownRef = React.useRef<HTMLDivElement>(null);
  // Fermeture des menus lors d'un clic à l'extérieur
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      //export button
      if (
        ExportDropdownRef.current &&
        !ExportDropdownRef.current.contains(event.target as Node)
      ) {
        setIsExportDropdownOpen(false);
      }

      //class button
      if (
        ClassDropdownRef.current &&
        !ClassDropdownRef.current.contains(event.target as Node)
      ) {
        setIsClassDropdownOpen(false);
      }

      //status button
      if (
        StatusDropdownRef.current &&
        !StatusDropdownRef.current.contains(event.target as Node)
      ) {
        setIsStatusDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  return (
    <div className="ml-60 w-full">
      {/* Header */}
      <Header
        isDarkMode={isDarkMode}
        setIsDarkMode={setIsDarkMode}
        toggleDarkMode={toggleDarkMode}
        currentYear={currentYear}
        isYearDropdownOpen={isYearDropdownOpen}
        toggleYearDropdown={toggleYearDropdown}
        setCurrentYear={setCurrentYear}
        setIsYearDropdownOpen={setIsYearDropdownOpen}
      />
      {/* Students Management Content */}
      <main className="p-6 mt-16">
        <div className="mb-6 flex justify-between items-center">
          <div>
            <h1 className="text-2xl font-bold mb-1">Gestion des élèves</h1>
            <p className={`${isDarkMode ? "text-gray-400" : "text-gray-600"}`}>
              Gérez les informations des élèves et leurs dossiers
            </p>
          </div>
          <div className="flex gap-3">
            <button
              className={`flex items-center px-4 py-2 rounded-md ${
                isDarkMode
                  ? "bg-blue-600 hover:bg-blue-700"
                  : "bg-blue-500 hover:bg-blue-600"
              } text-white !rounded-button whitespace-nowrap`}
            >
              <i className="fas fa-user-plus mr-2"></i>
              <span>Ajouter un élève</span>
            </button>
            <div className="relative" ref={ExportDropdownRef}>
              <button
                onClick={toggleExportDropdown}
                className={`flex items-center px-4 py-2 rounded-md ${
                  isDarkMode
                    ? "bg-[#161B22] hover:bg-gray-700"
                    : "bg-gray-100 hover:bg-gray-200"
                } !rounded-button whitespace-nowrap`}
              >
                <i className="fas fa-file-export mr-2"></i>
                <span>Exporter</span>
                <i className="fas fa-chevron-down ml-2"></i>
              </button>
              {isExportDropdownOpen && (
                <div
                  className={`absolute top-full right-0 mt-1 w-48 rounded-md shadow-lg ${
                    isDarkMode ? "bg-[#161B22]" : "bg-white"
                  } z-10 border ${
                    isDarkMode ? "border-gray-700" : "border-gray-300"
                  }`}
                >
                  <div className="py-1">
                    {/* <button
                      onClick={() => exportData("CSV")}
                      className={`flex items-center w-full px-4 py-2 text-sm text-left ${
                        isDarkMode ? "hover:bg-gray-700" : "hover:bg-gray-100"
                      } !rounded-button whitespace-nowrap`}
                    >
                      <i className="fas fa-file-csv mr-3"></i>
                      Exporter en CSV
                    </button> */}
                    <button
                      onClick={() => exportData("Excel")}
                      className={`flex items-center w-full px-4 py-2 text-sm text-left ${
                        isDarkMode ? "hover:bg-gray-700" : "hover:bg-gray-100"
                      } !rounded-button whitespace-nowrap`}
                    >
                      <i className="fas fa-file-excel mr-3"></i>
                      Exporter en Excel
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        {/* Search and Filters */}
        <div className="flex flex-wrap gap-4 mb-6">
          <div className="flex-grow relative">
            <div
              className={`absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-500`}
            >
              <i className="fas fa-search"></i>
            </div>
            <input
              type="text"
              placeholder="Rechercher un élève..."
              className={`w-full pl-10 pr-4 py-2 rounded-md text-sm ${
                isDarkMode
                  ? "bg-[#161B22] border-gray-700"
                  : "bg-white border-gray-300"
              } border focus:outline-none focus:ring-2 focus:ring-blue-500`}
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>
          {/* Class Filter */}
          <div className="relative" ref={ClassDropdownRef}>
            <button
              onClick={toggleClassDropdown}
              className={`flex items-center px-4 py-2 rounded-md ${
                isDarkMode
                  ? "bg-[#161B22] hover:bg-gray-700"
                  : "bg-white hover:bg-gray-100"
              } border ${
                isDarkMode ? "border-gray-700" : "border-gray-300"
              } !rounded-button whitespace-nowrap`}
            >
              <span>{selectedClass}</span>
              <i className="fas fa-chevron-down ml-2"></i>
            </button>
            {isClassDropdownOpen && (
              <div
                className={`absolute top-full right-0 mt-1 w-48 rounded-md shadow-lg ${
                  isDarkMode ? "bg-[#161B22]" : "bg-white"
                } z-10 border ${
                  isDarkMode ? "border-gray-700" : "border-gray-300"
                }`}
              >
                <div className="py-1">
                  <button
                    onClick={() => {
                      setSelectedClass("Toutes les classes");
                      setIsClassDropdownOpen(false);
                    }}
                    className={`block px-4 py-2 text-sm w-full text-left ${
                      isDarkMode ? "hover:bg-gray-700" : "hover:bg-gray-100"
                    } !rounded-button whitespace-nowrap`}
                  >
                    Toutes les classes
                  </button>

                  {dataClasses.map((classe) => (
                    <button
                      onClick={() => {
                        setSelectedClass(classe.designation || "");
                        setIsClassDropdownOpen(false);
                      }}
                      className={`block px-4 py-2 text-sm w-full text-left ${
                        isDarkMode ? "hover:bg-gray-700" : "hover:bg-gray-100"
                      } !rounded-button whitespace-nowrap`}
                    >
                      {classe.designation}
                    </button>
                  ))}
                </div>
              </div>
            )}
          </div>
          {/* Status Filter */}
          <div className="relative" ref={StatusDropdownRef}>
            <button
              onClick={toggleStatusDropdown}
              className={`flex items-center px-4 py-2 rounded-md ${
                isDarkMode
                  ? "bg-[#161B22] hover:bg-gray-700"
                  : "bg-white hover:bg-gray-100"
              } border ${
                isDarkMode ? "border-gray-700" : "border-gray-300"
              } !rounded-button whitespace-nowrap`}
            >
              <span>
                {selectedStatus === 1
                  ? "Actif"
                  : selectedStatus === 0
                  ? "Inactif"
                  : "Tous les statuts"}
              </span>
              <i className="fas fa-chevron-down ml-2"></i>
            </button>
            {isStatusDropdownOpen && (
              <div
                className={`absolute top-full right-0 mt-1 w-48 rounded-md shadow-lg ${
                  isDarkMode ? "bg-[#161B22]" : "bg-white"
                } z-10 border ${
                  isDarkMode ? "border-gray-700" : "border-gray-300"
                }`}
              >
                <div className="py-1">
                  <button
                    onClick={() => {
                      setSelectedStatus("Tous les statuts");
                      setIsStatusDropdownOpen(false);
                    }}
                    className={`block px-4 py-2 text-sm w-full text-left ${
                      isDarkMode ? "hover:bg-gray-700" : "hover:bg-gray-100"
                    } !rounded-button whitespace-nowrap`}
                  >
                    Tous les statuts
                  </button>
                  <button
                    onClick={() => {
                      setSelectedStatus(1);
                      setIsStatusDropdownOpen(false);
                    }}
                    className={`block px-4 py-2 text-sm w-full text-left ${
                      isDarkMode ? "hover:bg-gray-700" : "hover:bg-gray-100"
                    } !rounded-button whitespace-nowrap`}
                  >
                    Actif
                  </button>
                  <button
                    onClick={() => {
                      setSelectedStatus(0);
                      setIsStatusDropdownOpen(false);
                    }}
                    className={`block px-4 py-2 text-sm w-full text-left ${
                      isDarkMode ? "hover:bg-gray-700" : "hover:bg-gray-100"
                    } !rounded-button whitespace-nowrap`}
                  >
                    Inactif
                  </button>
                </div>
              </div>
            )}
          </div>
          {/* Filter Button */}
          <button
            className={`px-4 py-2 rounded-md ${
              isDarkMode
                ? "bg-[#161B22] hover:bg-gray-700"
                : "bg-white hover:bg-gray-100"
            } border ${
              isDarkMode ? "border-gray-700" : "border-gray-300"
            } !rounded-button whitespace-nowrap`}
          >
            <i className="fas fa-filter"></i>
          </button>
        </div>
        {/* View Toggle */}
        <div className="mb-6">
          <div
            className={`inline-flex rounded-md overflow-hidden border ${
              isDarkMode ? "border-gray-700" : "border-gray-300"
            }`}
          >
            <button
              className={`px-4 py-2 ${
                viewMode === "liste"
                  ? isDarkMode
                    ? "bg-gray-700"
                    : "bg-gray-200"
                  : isDarkMode
                  ? "bg-[#161B22]"
                  : "bg-white"
              } !rounded-button whitespace-nowrap`}
              onClick={() => setViewMode("liste")}
            >
              <i className="fas fa-list mr-2"></i>
              Liste
            </button>
            <button
              className={`px-4 py-2 ${
                viewMode === "cartes"
                  ? isDarkMode
                    ? "bg-gray-700"
                    : "bg-gray-200"
                  : isDarkMode
                  ? "bg-[#161B22]"
                  : "bg-white"
              } !rounded-button whitespace-nowrap`}
              onClick={() => setViewMode("cartes")}
            >
              <i className="fas fa-th-large mr-2"></i>
              Cartes
            </button>
          </div>
        </div>
        {/* Students List View */}
        {viewMode === "liste" && (
          <div
            className={`rounded-lg overflow-hidden border ${
              isDarkMode ? "border-gray-700" : "border-gray-300"
            }`}
          >
            <table className="min-w-full divide-y divide-gray-700">
              <thead
                className={`${isDarkMode ? "bg-[#161B22]" : "bg-gray-50"}`}
              >
                <tr>
                  <th
                    scope="col"
                    className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider"
                  >
                    Noms
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider"
                  >
                    Classe
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider"
                  >
                    Genre
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider"
                  >
                    Date de naissance
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider"
                  >
                    Parent
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider"
                  >
                    Contact
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider"
                  >
                    Statut
                  </th>
                </tr>
              </thead>
              <tbody
                className={`${
                  isDarkMode ? "bg-[#0D1117]" : "bg-white"
                } divide-y ${
                  isDarkMode ? "divide-gray-700" : "divide-gray-200"
                }`}
              >
                {currentStudents.map((student) => {
                  // console.log(student.classeDesignation);
                  return (
                    <tr
                      key={student.eleve_id}
                      className={`${
                        isDarkMode ? "hover:bg-gray-800" : "hover:bg-gray-50"
                      }`}
                      onClick={() => handleNavigateToStudentDetails(student)}
                    >
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div
                          className={`${
                            isDarkMode ? "text-gray-300" : "text-gray-700"
                          }`}
                        >
                          {student.nom} {student.postnom}{" "}
                          {capitalizeFirstLetter(student.prenom)}
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        {student.classeDesignation || "-----------------"}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        {student.sexe === "M" ? "Masculin" : "Féminin"}
                      </td>
                      <td className="px-6 py-4 text-center whitespace-nowrap">
                        {moment(student.date_naissance).format("DD/MM/YYYY")}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        {student.parentData?.nom ||
                        student.parentData?.postnom ||
                        student.parentData?.prenom
                          ? `${student.parentData.nom} ${student.parentData.postnom} ${student.parentData.prenom}`
                          : "-----------------"}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        {student.telephone}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <span
                          className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${
                            student.status
                              ? "bg-green-100 text-green-800"
                              : "bg-red-100 text-red-800"
                          }`}
                        >
                          {student.status ? "Actif" : "Inactif"}
                        </span>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
        {/* Students Cards View */}
        {viewMode === "cartes" && (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {currentStudents.map((student) => {
              // let parentData, promotionData, classeDesignation;

              // for (const parent of dataParentArr) {
              //   if (parent.id === student.parent_id) {
              //     parentData = parent;
              //   }
              // }
              // for (const promotion of dataPromotionArr) {
              //   if (
              //     promotion.annee_scolaire_id === schoolYear?.data[0].id &&
              //     promotion.eleve_id === student.eleve_id
              //   ) {
              //     promotionData = promotion;
              //   }
              // }
              // for (const classe of dataClasses) {
              //   if (promotionData?.classe_id === classe.id) {
              //     classeDesignation = classe.designation;
              //   }
              // }

              return (
                <div
                  key={student.id}
                  className={`rounded-lg overflow-hidden border ${
                    isDarkMode ? "border-gray-700" : "border-gray-300"
                  } shadow-sm`}
                >
                  <div
                    className={`p-4 ${
                      isDarkMode ? "bg-[#161B22]" : "bg-gray-50"
                    } border-b ${
                      isDarkMode ? "border-gray-700" : "border-gray-200"
                    }`}
                  >
                    <div className="flex justify-between items-center">
                      <h3 className="font-medium">
                        {student.nom} {student.postnom}{" "}
                        {capitalizeFirstLetter(student.prenom)}
                      </h3>
                      <span
                        className={`px-2 py-1 text-xs font-semibold rounded-full ${
                          student.status
                            ? "bg-green-100 text-green-800"
                            : "bg-red-100 text-red-800"
                        }`}
                      >
                        {student.status ? "Actif" : "Inactif"}
                      </span>
                    </div>
                  </div>
                  <div
                    className={`p-4 ${
                      isDarkMode ? "bg-[#0D1117]" : "bg-white"
                    }`}
                  >
                    <div className="space-y-2">
                      <div className="flex justify-between">
                        <span
                          className={`text-sm ${
                            isDarkMode ? "text-gray-400" : "text-gray-500"
                          }`}
                        >
                          Classe:
                        </span>
                        <span className="text-sm">
                          {student.classeDesignation}
                        </span>
                      </div>
                      <div className="flex justify-between">
                        <span
                          className={`text-sm ${
                            isDarkMode ? "text-gray-400" : "text-gray-500"
                          }`}
                        >
                          Date de naissance:
                        </span>
                        <span className="text-sm">
                          {moment(student.date_naissance).format("DD/MM/YYYY")}
                        </span>
                      </div>
                      <div className="flex justify-between">
                        <span
                          className={`text-sm ${
                            isDarkMode ? "text-gray-400" : "text-gray-500"
                          }`}
                        >
                          Parent:
                        </span>
                        <span className="text-sm">
                          {student.parentData?.nom ||
                          student.parentData?.postnom ||
                          student.parentData?.prenom
                            ? `${
                                student.parentData?.nom
                              } ${capitalizeFirstLetter(
                                student.parentData?.prenom
                              )}`
                            : "----------------"}
                        </span>
                      </div>
                      <div className="flex justify-between">
                        <span
                          className={`text-sm ${
                            isDarkMode ? "text-gray-400" : "text-gray-500"
                          }`}
                        >
                          Contact:
                        </span>
                        <span>{student.telephone}</span>
                      </div>
                    </div>
                    <div className="mt-4 flex justify-between">
                      <a
                        href="#"
                        data-readdy="true"
                        className={`px-3 py-1 rounded text-sm ${
                          isDarkMode
                            ? "bg-blue-900 hover:bg-blue-800"
                            : "bg-blue-100 hover:bg-blue-200"
                        } text-blue-500 !rounded-button whitespace-nowrap`}
                      >
                        <i className="fas fa-eye mr-1"></i> Détails
                      </a>
                      <button
                        className={`px-3 py-1 rounded text-sm ${
                          isDarkMode
                            ? "bg-green-900 hover:bg-green-800"
                            : "bg-green-100 hover:bg-green-200"
                        } text-green-500 !rounded-button whitespace-nowrap`}
                      >
                        <i className="fas fa-edit mr-1"></i> Modifier
                      </button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
        {/* Pagination */}
        <div className="mt-6 flex items-center justify-between">
          <div
            className={`text-sm ${
              isDarkMode ? "text-gray-400" : "text-gray-600"
            }`}
          >
            Affichage de {indexOfFirstStudent + 1} à{" "}
            {Math.min(indexOfLastStudent, filteredStudents.length)} sur{" "}
            {filteredStudents.length} élèves
          </div>
          <div className="flex space-x-2">
            <button
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
              className={`px-3 py-1 rounded-md ${
                isDarkMode
                  ? "bg-[#161B22] hover:bg-gray-700"
                  : "bg-white hover:bg-gray-100"
              } border ${
                isDarkMode ? "border-gray-700" : "border-gray-300"
              } !rounded-button whitespace-nowrap ${
                currentPage === 1 ? "opacity-50 cursor-not-allowed" : ""
              }`}
            >
              <i className="fas fa-chevron-left"></i>
            </button>
            {[...Array(totalPages)].map((_, index) => (
              <button
                key={index + 1}
                onClick={() => handlePageChange(index + 1)}
                className={`px-3 py-1 rounded-md ${
                  currentPage === index + 1
                    ? `${isDarkMode ? "bg-blue-600" : "bg-blue-500"} text-white`
                    : `${
                        isDarkMode
                          ? "bg-[#161B22] hover:bg-gray-700"
                          : "bg-white hover:bg-gray-100"
                      } border ${
                        isDarkMode ? "border-gray-700" : "border-gray-300"
                      }`
                } !rounded-button whitespace-nowrap`}
              >
                {index + 1}
              </button>
            ))}
            <button
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
              className={`px-3 py-1 rounded-md ${
                isDarkMode
                  ? "bg-[#161B22] hover:bg-gray-700"
                  : "bg-white hover:bg-gray-100"
              } border ${
                isDarkMode ? "border-gray-700" : "border-gray-300"
              } !rounded-button whitespace-nowrap ${
                currentPage === totalPages
                  ? "opacity-50 cursor-not-allowed"
                  : ""
              }`}
            >
              <i className="fas fa-chevron-right"></i>
            </button>
          </div>
        </div>
      </main>
    </div>
  );
};
export default Student;
